import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import { store } from 'lib/stores';
import 'nprogress/nprogress.css';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import 'styles/global.scss';
import App from './App';

if (import.meta.env.DEV) {
  const originalError = console.error;
  console.error = (...args) => {
    if (
      typeof args[0] === 'string' &&
      args[0].includes('findDOMNode is deprecated')
    )
      return;
    originalError.call(console, ...args);
  };
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <Provider store={store}>
    <App />
  </Provider>
);
